import axios from '../http_v2'

import type from './active/type'
import share from './active/socialShare'
import ticket from './active/ticket'
import hall from  './active/hall'
import form from './active/form'
import guest from './active/guest'
import market from './active/market'
import schedule from './active/schedule'
import file from './active/file'
import person from './active/person'
import liaison from './active/liaison'
import resource from './active/resource'
import wechat from './active/wechat'
import live from './active/live'
import screen from './active/screen'
import activeSession from './active/activeSession'
import xiezuo from './active/xiezuo'
let get = (params) => {
  return axios.get('activityservice/activitysearch/findone', params)
}

let list = (data) => {
  return axios.post('activityservice/activitysearch/page', data)
}

let add = (data) => {
  return axios.post('activityservice/activityinfo/insert', data)
}

let update = (data) => {
  return axios.post('activityservice/activityinfo/update', data)
}

let getCategory = (data) => {
  // 获取所有的活动类型
  return axios.post('opservice/opbasedocactivitytype/list', data)
}

// 获取直播的数据
let getLiveReportData = (data) => {
  return axios.post('activityservice/activitylive/bg/count/list', data)
}

// 获取直播的详情数据
let getLiveDetailData = (data) => {
  return axios.post('activityservice/activitylive/bg/count/detail/list', data)
}

// 删除活动
let deteleActive = (data) => {
  return axios.post('activityservice/activityinfo/delete', data)
}

// 获取回收站列表
let getRecycleList = (data) => {
  return axios.post('activityservice/activitysearch/recycle/page', data)
}

let getRecover = (data) => {
  return axios.post('activityservice/activitysearch/recycle/do', data)
}
// 活动统计列表
let activeReportList = (data) => {
  return axios.post('activityservice/activitysearch/page/detailcount', data)
}

//机构统计列表
let activeCompanyList = (data)=>{
  return axios.post('activityservice/statistics/activity/org',data)
}

// 机构参会人数折线图
let peopleNumCanvas = (data)=>{
  return axios.post('activityservice/activitysearch/prticipant/count/byorg',data)
}

// 机构活动数折线图
let activeNumCanvas = (data)=>{
  return axios.post('activityservice/activitysearch/activity/count/byorg',data)
}

// 导出活动统计列表
let exportActiveReportList = (data) => {
  return axios.post('activityservice/activitysearch/page/detailcount/excel', data, {responseType: 'blob' })
}

let exportCompanyReportList = (data) => {
  return axios.post('activityservice/statistics/activity/org/down', data, {responseType: 'blob' })
}
let productList = (data) => {
  return axios.get('cmsservice/productSort/op/tree')
}
export default {
  allActive: (params) => {
    return axios.post('activityservice/activitysearch/html/page', params)
  },
  get,
  list,
  add,
  update,
  activeReportList,
  activeCompanyList,
  exportActiveReportList,
  exportCompanyReportList,
  peopleNumCanvas,
  activeNumCanvas,
  market,   // 全员营销
  type,     // 活动分类
  share,    // 活动分享
  ticket,   // 门票管理
  form,     // 表单管理
  hall,     // 分会场管理
  guest,    // 嘉宾管理
  schedule, // 日程管理
  file,     // 文件管理
  person,   // 参会人管理
  liaison,  // 联络人管理
  resource, // 资源配合管理
  wechat,   // 微信签到
  live,     // 直播管理
  screen,   // 大屏幕管理
  activeSession, // 活动统计
  productList,
  xiezuo, // 协作设计


  signPoint: {
    // 签到点管理
    list: (params) => {
      return axios.get('activityservice/activityassistant/query', params)
    },
    person: (params) => {
      return axios.post('activityservice/activityassistant/prticipantpage/withcontact', params)
    },
    export: (params) => {
      return axios.post('activityservice/activityassistant/signLog/export', params)
    }
  },
  // 活动专题
  home: {
    page(params) {
      return axios.get('activityservice/video/subject/page', params)
    },
    save (params) {
      return axios.post('activityservice/video/subject/save', params)
    },
    del (params) {
      return axios.get('activityservice/video/subject/delete/id', params)
    }
  },
  banner:{
    personInfo() {
      return axios.get('opservice/tenant/current')
    },
    getManage() {
      return axios.get('opservice/wechatmanage/get_by_current_user')
    },
    tree(params) {
      return axios.get('cmsservice/productSort/tree', params)
    },
    gethomepage(params) {
      return axios.get('cmsservice/cms_homepage/get', params)
    },
    savehomepage(params) {
      return axios.post('cmsservice/cms_homepage/save', params)
    },
    list(params) {
      return axios.get('cmsservice/cms_homebanner/page/list', params)
    },
    save(params) {
      return axios.post('cmsservice/cms_homebanner/save', params)
    },
    del(params) {
      return axios.post('cmsservice/cms_homebanner/delete', params)
    },
  },
  report: {
    shareRankingCorp: (params) => {
      return axios.post('marketcenter/share/groupby/company/detail', params)
    },
    shareRankingPerson: (params) => {
      return axios.post('marketcenter/share/groupby/phone/detail', params)
    },
    exportShareRankingCorp: (params) => {
      return axios.post('marketcenter/share/groupby/company/detail/export', params)
    },
    exportShareRankingPerson: (params) => {
      return axios.post('marketcenter/share/groupby/phone/detail/export', params)
    }
  },

  getCategory, //活动类型  运营平台配置
  // 获取直播的报表数据
  getLiveReportData,
  getLiveDetailData,
  deteleActive,
  getRecycleList,
  getRecover
}
